import React, { Component } from "react";
import { MyContext } from "../../context";
import { Spinner, Stack } from "office-ui-fabric-react";
import { ConversationSafeList } from "./ConversationSafeList";
import { getCasesMyQueue } from "./ConversationSafeQuery";

export default class MyQueue extends Component {
    static contextType = MyContext;

    constructor(props) {
        super(props);
        this.state = {
            caseManagementFolders: [],
            loading: false,
        };
    }

    componentDidMount() {
        this.refreshPage();
    }

    authRights = (data) => {
        let folders = data.getCasesMyQueue;
        let ownFolderRule = this.props.userRules.ruleAccess.ownFolder;
        let user = this.props.userRules.userId;

        if (this.props.userRules.ruleAccess.userSafe == "Full") {
            return folders.map((folder) => {
                let userIsCreator = folder.userId == user;
                return {
                    folderId: folder.id,
                    addConvRight: true,
                    removeConvRight: true,
                    upserRight: true,
                    deleteFolder: true,
                    exportFolder: true,
                    userIsCreator,
                };
            });
        }

        return folders.map((folder) => {
            let userIsCreator = folder.userId == user;
            let userIsAssignee = folder.supervisors.map((e) => e.userId).includes(user);
            let addConvRight = (ownFolderRule.addConversations && userIsCreator) || (userIsAssignee && folder.addConversations);
            let removeConvRight = (ownFolderRule.removeConversations && userIsCreator) || (userIsAssignee && folder.removeConversations);
            let upserRight = ownFolderRule.upserFolder && userIsCreator;
            let deleteFolder = userIsCreator && ownFolderRule.deleteFolders;
            let exportFolder = (ownFolderRule.exportFolders && userIsCreator) || (userIsAssignee && folder.exportFolders);
            return {
                folderId: folder.id,
                addConvRight,
                removeConvRight,
                upserRight,
                deleteFolder,
                userIsCreator,
                exportFolder,
            };
        });
    };

    refreshPage = () => {
        this.setState({ loading: true });
        this.props.apol
            .query({
                query: getCasesMyQueue,
                variables: { auth: this.props.auth },
                fetchPolicy: "network-only",
            })
            .then((result) => {
                const { getCasesMyQueue } = result.data;

                let rightsArray = this.authRights(result.data);
                this.setState({
                    loading: false,
                    caseManagementFolders: getCasesMyQueue,
                    rights: rightsArray,
                });
            });
    };

    render() {
        return (
            <div style={{ overflow: "auto", maxHeight: window.innerHeight - 120, position: "relative", marginTop: "5px" }}>
                <Stack style={{ marginTop: "10px" }}>
                    {this.state.loading && <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />}
                    {!this.state.loading && (
                        <ConversationSafeList
                            isMyQueue={true}
                            data={this.state.caseManagementFolders}
                            rights={this.state.rights}
                            auth={this.props.auth}
                            apol={this.props.apol}
                            userRules={this.props.userRules}
                            theme={this.props.theme}
                            refreshCSList={this.refreshPage}
                        />
                    )}
                </Stack>
            </div>
        );
    }
}
